import React from "react";
import { Button } from "react-md";
import FrmLogin from "../forms/FrmLogin";
import FrmNewUser from "../forms/FrmNewUser";
import FrmForgotPass from "../forms/FrmForgotPass";
import FrmCambiarContrasena from "../forms/FrmCambiarContrasena";
import {
  loginAuth,
  newUser,
  recuperaPass,
  axGuardarNuevaContrasena,
  validarCorreo,
} from "../requests/req_menu";
import { notifica, amb, show_ldr } from "../requests/utils";
import { getPerfil } from "../requests/req_perfil";
import { postPostularCandidato } from "../requests/req_ofertas";
import Swal from "sweetalert2";

const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};
export default class LoginOld extends React.Component {
  state = { MN: null, errors: {} };

  componentDidMount() {
    const { accion, id, mail } = this.props;
    //console.log('accion :>> ', accion);
    switch (accion) {
      case "cambiarContrasena":
        if (id === null || id === undefined || id === "") {
          window.location.href = "/";
        }
        break;
      case "valida":
        validarCorreo({ Correo: mail });
        break;
      default:
        break;
    }
  }

  tipoLogin = (tipo) => {
    const { accion, mail } = this.props;
    switch (tipo) {
      case "olvidada":
        return <FrmForgotPass />;
      case "new":
        return <FrmNewUser errors={this.state.errors} />;
      case "cambiarContrasena":
        return (
          <FrmCambiarContrasena
            action={accion}
            callback={this.clickLog}
          ></FrmCambiarContrasena>
        );
      case "valida":
        return (
          <div className="ARC_Lgn_dv">
            <h1>¡Te damos la Bienvenida!</h1>
            <p>Tu correo : {mail} a sido validado</p>
          </div>
        );
      default:
        return <FrmLogin />;
    }
  };

  tipoHead = (tipo) => {
    switch (tipo) {
      case "olvidada":
        return <div className="ARC_Lgn_Hd">Recuperar Contraseña</div>;
      case "new":
        return <div className="ARC_Lgn_Hd">Registrarse</div>;
      case "cambiarContrasena":
        return <div className="ARC_Lgn_Hd">Cambiar Contraseña</div>;
      case "valida":
        return <div className="ARC_Lgn_Hd">Correo Validado</div>;
      default:
        return <div className="ARC_Lgn_Hd">Iniciar Sesión</div>;
    }
  };
  validateEmail = () => {
    let usr = document.getElementById("IdUsuario").value;
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(usr).toLowerCase());
  };

  clickLog = (e) => {
    e.preventDefault();
    switch (this.props.accion) {
      case "olvidada":
        var usr = document.getElementById("IdUsuario");
        if (usr) {
          if (usr.value === "" || usr.value.length === 0) {
            notifica("warning", "El correo es obligartorio", "");
            break;
          }
        } else {
          notifica("warning", "El correo es obligartorio", "");
        }

        recuperaPass((x) => this.recPass(x));
        break;
      case "new":
        let regE = new RegExp(/^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/);
        let regNM = new RegExp(/^[ÁÉÍÓÚéúíáóñA-Za-z /s]*$/);
        let regTE = new RegExp(/^[0-9]{10,10}$/);
        let regCP = new RegExp(/^[0-9]{5,5}$/);
        let vfcorreo = document.getElementById("vfcorreo").value;
        let correo = document.getElementById("correo").value;
        let nm = document.getElementById("nombre").value;
        let pat = document.getElementById("apellidoPaterno").value;
        let mat = document.getElementById("apellidoMaterno").value;
        let pass = document.getElementById("IdPass").value;
        let cdpstl = document.getElementById("codigoPostal").value;
        let telf = document.getElementById("Telefono1").value;
        let flag = true;
        let errors = {};

        if (regNM.test(nm) === false || nm === "") {
          errors.nombre = "El campo nombre es incorrecto";
          flag = false;
        }
        if (regNM.test(pat) === false || pat === "") {
          errors.apellidoPa = "El campo apellido paterno es incorrecto";
          flag = false;
        }

        if (regNM.test(mat) === false || mat === "") {
          errors.apellidoMa = "El campo apellido materno es incorrecto";

          flag = false;
        }
        if (regCP.test(cdpstl) === false) {
          errors.codigoP = "El campo código postal es incorrecto";
          flag = false;
        }
        if (regTE.test(telf) === false || telf === "") {
          errors.tel = "Ingresa un número válido de 10 posiciones";
          flag = false;
        }
        if (regE.test(correo) === false) {
          errors.correo = "El campo correo es incorrecto";
          flag = false;
        }
        if (correo.trim() !== vfcorreo.trim()) {
          errors.vfCorreo =
            "La verificación de correo debe de ser igual al correo";
          flag = false;
        }

        if (pass === "") {
          errors.pass = "El campo contraseña es incorrecto";
          flag = false;
        }

        if (Object.keys(errors).length) {
          this.setState({
            errors,
          });
          return;
        }

        newUser((l) => this.newLogin(l));

        break;
      case "login":
        if (!this.validateEmail())
          return notifica("warning", "Ingrese un correo valido", "Alerta");
        loginAuth((l) => this.ActionResult(l));
        break;
      case "cambiarContrasena":
        var newPass = document.getElementById("IdNewPass").value;
        var confPass = document.getElementById("IdConfPass").value;

        if (newPass === "" || newPass === null) {
          notifica("warning", "Aún no ingresas la contraseña", "");
        } else if (confPass === "" || confPass === null) {
          notifica(
            "warning",
            "Aún no ingresas la contraseña de confirmación",
            ""
          );
        } else {
          if (confPass !== newPass) {
            notifica(
              "warning",
              "La contraseña de confirmación no coincide",
              ""
            );
          } else {
            axGuardarNuevaContrasena(newPass, parseInt(atob(this.props.id)));
          }
        }

        break;
      default:
        break;
    }
  };

  recPass = (datos) => {
    var url = window.location.origin;

    if (datos.code === 0) {
      Swal.fire({
        title: "Mensaje",
        text: "Se ha enviado un correo con la información para su login al portal.",
        icon: "success",
        confirmButtonText: "Regresar",
        allowOutsideClick: false,
        preConfirm: () => {
          window.location.href = url;
        },
      });
    } else {
      Swal.fire({
        title: "Mensaje",
        text: datos.message,
        icon: "warning",
        confirmButtonText: "Regresar",
        allowOutsideClick: false,
        preConfirm: () => {
          // window.location.href=url;
        },
      });
    }
  };
  newLogin = (datos) => {
    if (datos) {
      sleep(1000).then(() => {
        var cv = window.location.origin;
        window.location.href = cv;
      });
    } else {
      notifica("warning", datos.message, "");
    }
  };
  asignarfoto = (data) => {
    var Item = data.data;
    localStorage.removeItem("foto");
    localStorage.setItem(
      "foto",
      Item[0].tabla2[0].foto !== ""
        ? Item[0].tabla2[0].foto
        : process.env.PUBLIC_URL + "/images/default-avatar.png"
    );
  };
  ActionResult = (datos) => {
    if (datos.code === 0) {
      var dts = datos.data;
      if (dts.length === 1) {
        var bs64 = btoa(unescape(encodeURIComponent(JSON.stringify(dts))));
        sessionStorage.setItem(amb + "_User", bs64);
        var cv = window.location.origin + "/perfil";

        // getPerfil(p => this.asignarfoto(p));

        //this.timer=setTimeout(() =>   getPerfil(p => this.asignarfoto(p)), 3000);
        getPerfil((p) => this.asignarfoto(p));
        if (localStorage.getItem("post") != null) {
          var data = localStorage.getItem("post");
          data = JSON.parse(data);
          var item = {
            idSolicitud: data != null ? parseInt(data.idSolicitud, 10) : 0,
            idZonificacion:
              data != null ? parseInt(data.idZonificacion, 10) : 0,
          };

          this.postularse();
        } else {
          sleep(1000).then(() => {
            window.location.href = cv;
          });
        }
      } else {
        //notifica("success", datos.message, "Su cuenta se creo correctamente.");
        notifica("warning", datos.message, "");
        document.getElementById("Id_login").click();
      }
    } else {
      notifica("warning", datos.message, "");
    }
  };

  async postularse() {
    let request = await postPostularCandidato();
    let cv = window.location.origin + "/perfil";
    if (Object.keys(request).length > 0) {
      localStorage.removeItem("post");
      show_ldr(false);
      window.location.href = cv;
    }
  }
  render() {
    const { accion } = this.props;
    return (
      <div className="ARC_Login">
        <div
          className="ARC_Lgn_Frm"
          style={accion && accion === "new" ? { height: "440px" } : null}
        >
          {this.tipoHead(accion)}
          {this.tipoLogin(accion)}
          {accion !== "valida" ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                floating
                primary
                className="frm_login_button"
                onClick={this.clickLog}
                id="Frm_btn_Lgn"
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/icon_right_arrow_sml_w.png"
                  }
                  alt=" "
                />
              </Button>
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    );
  }
}
